import React from "react";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { Query } from "react-apollo";

import { css } from "glamor";
import { Button } from "antd";

import { withApolloState } from "../../util/apollo";
import authFetch from "../../api/authFetch";
import { BulkActionsButton } from "./BulkActionsUploader";

const styles = {
    actionButton: css({
        marginLeft: ".5rem",
    }),
};

// `hookType: 2` corresponds to action hooks for the entity store page.
// TODO: add proper enum support for this field
const ENTITY_STORE_ACTIONS = gql`
    query EntityStoreActionsQuery {
        clientConfig {
            hooks(hookType: 2) {
                type
                label
                link
                priority
                permissions {
                    entity {
                        canCreate
                    }
                }
            }
        }
        permissions {
            entity {
                canCreate
            }
        }
    }
`;

// Taken from 590ec78e
// NOTE: we should probably filter the hooks at an API-level
// OR simplify the permission matrix.
const hookFilter = permissions => hook =>
    !hook.permissions.entity.canCreate || permissions.entity.canCreate;

// the `style` attribute is used for the border (as opposed to adding to
// `...styles.actionButton` to ensure that the hover state also keeps
// the border...
export const ActionButton = ({ label, action = () => {}, icon }) => (
    <Button
        {...styles.actionButton}
        data-at-id={label}
        style={{ border: "1px solid rgba(255, 255, 255, 0.4)" }}
        type="primary"
        icon={icon}
        size="large"
        onClick={action}
    >
        {label}
    </Button>
);

class ActionMenu extends React.Component {
    handleAction = link => async e => {
        e.preventDefault();
        const request = new Request(link, {
            method: "POST",
            body: "{}",
        });
        const response = await authFetch(request);
        const jsonRes = await response.json();
        const nextTaskID = jsonRes.next_task_id;
        const { history } = this.props;
        if (nextTaskID) {
            history.push(`/tasks/${nextTaskID}/claim/`);
        } else {
            history.push("/tasks/");
        }
    };

    render() {
        return (
            <Query query={ENTITY_STORE_ACTIONS} fetchPolicy="cache-and-network">
                {withApolloState(({ data }) => {
                    const { hooks } = data.clientConfig;

                    return hooks
                        .sort((a, b) => a.priority - b.priority)
                        .filter(hookFilter(data.permissions))
                        .map(({ label, link }) => {
                            switch (label) {
                                case "Bulk actions":
                                    return <BulkActionsButton key={label} />;
                                default:
                                    return (
                                        <ActionButton
                                            icon="plus-circle"
                                            label={label}
                                            key={label}
                                            action={this.handleAction(link)}
                                        />
                                    );
                            }
                        });
                })}
            </Query>
        );
    }
}

export default withRouter(ActionMenu);
